import { addPatientToPacs, schedulePatientMwl, checkDcmPatById } from '../Apis/apis';

export async function fetchPatientCount(PatientID: string) {
	const queryParams = {
		includefield: 'all',
    PatientID,
  };

  try {
		const response = await checkDcmPatById(queryParams);
    if (response?.ok) {
			const data = await response?.json();
    	return data;
    }
		else{
			console.error('Error:', response?.status, response?.statusText);
		}

  } catch (error) {
    console.error('Error fetching patient count:', error);
  }

	return null;
}

export async function postPatientData({patName, patId, patIdIssuer, patDob, patSex}) {

	// 00100010 - Patient's Name (vr: PN)   // "Family Name^Given Name^Middle Name^Name Prefix^Name Suffix"
	// 00100020 - Patient ID (vr: LO)
	// 00100021 - Issuer of Patient ID (vr: LO)
	// 00100030 - Patient's Birth Date (vr: DA)   // "YYYYMMDD"
	// 00100040 - Patient's Sex (vr: CS)   // "M", "F" or "O"
	const hospitalCode = sessionStorage.getItem('hospitalCode') || localStorage.getItem('hospitalCode');
	const payload = {
		'00100010': { vr: 'PN', Value: [{ Alphabetic: patName }] },
		'00100020': { vr: 'LO', Value: [patId] },
		'00100021': { vr: 'LO', Value: [ hospitalCode || patIdIssuer] },
		'00100030': { vr: 'DA', Value: [patDob] },
		'00100040': { vr: 'CS', Value: [patSex] },
	};

	try {
		const response = await addPatientToPacs(payload)

		if (response?.ok) {
			const data = await response?.json();
			return true;
		} else {
			console.error('Error:', response?.status, response?.statusText);
			return false;
		}

	} catch (error) {
		console.error('Fetch error:', error);
		return false;
	}
}

export async function postMWLItems({patId, modality, stepProcedureDisc, accessionNumber, aeTitle, patAge}) {

	// 00100020 - Patient ID (vr: LO)
	// 00100021 - Issuer of Patient ID (vr: LO)
	// 00400100 - Scheduled Procedure Step Sequence (vr: SQ)
	// 00400001 - Scheduled Station AE Title (vr: AE)
	// 00400009 - Scheduled Procedure Step ID (vr: SH)
	// 00080060 - Modality (vr: CS)
	// 00400007 - Scheduled Procedure Step Description (vr: LO)
	// 0020000D - Study Instance UID (vr: UI)
	// 00080050 - Accession Number (vr: SH)
	// 00401001 - Requested Procedure ID (vr: SH)
	// 00741202 - Entrance Dose in mGy (vr: LO)

	const hospitalCode = sessionStorage.getItem('hospitalCode') || localStorage.getItem('hospitalCode');

	const payload = {
		'00100020': { vr: 'LO', Value: [patId] },
		    "00101010": {
      vr: "AS",
      Value: [patAge],           // Age, e.g. "024Y"
    },
		'00100021': { vr: 'LO' },
		'00400100': {
			vr: 'SQ',
			Value: [
				{
					'00400001': { vr: 'AE', Value: [aeTitle] },
					'00400009': { vr: 'SH', Value: [''] },
					'00080060': { vr: 'CS', Value: [modality] },
					'00400007': {
						vr: 'LO',
						Value: [stepProcedureDisc],
					},
				},
			],
		},
		'0020000D': { vr: 'UI', Value: [''] },
		'00080050': { vr: 'SH', Value: [accessionNumber] },
		'00401001': { vr: 'SH', Value: [''] },
		'00741202': { vr: 'LO', Value: [''] },
		"00080080": { vr: "LO", Value: [hospitalCode]},
	};

	try {
		const response = await schedulePatientMwl(payload);

		if (response?.ok) {
			const data = await response?.json();
			return true;

		} else {
			console.error('Error:', response?.status, response?.statusText);
		}
	} catch (error) {
		console.error('Fetch error:', error);
	}

	return false;
}
